import { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { currency_icon } from "@/constants";

export const usePrice = () => {
    const curr = useSelector((state) => state.common.curr);

    const currencyIcons = useMemo(() => currency_icon, []);

    const formatAmount = useCallback((amount) => {
        return `${currencyIcons[curr]}${amount}`;
    }, [curr, currencyIcons]);

    return formatAmount;
};
